// // New Component


// import React, { useEffect, useRef, useState } from 'react';
// import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
// import { LeadFormActions } from '../../../Services/_actions/index.js';
// import { dateFormate } from '../../../utils/helper.jsx';
// import {
//   List,
//   ListItem,
//   ListItemText,
//   ListItemSecondaryAction,
//   Box,
//   Chip,
//   IconButton,
//   Tooltip,
//   Typography,
// } from '@mui/material';
// import { Visibility as VisibilityIcon } from '@mui/icons-material';
// import { phoneNumberAllLeadsAtom } from '../../../Services/_states/index.js';
// import { useRecoilState } from 'recoil';
// import { Lead, Pagination } from '../../../interfaces/Leads.interface.ts';

// type ApiResponse = {
//   status?: boolean;
//   data?: { leads?: Lead[]; pagination?: Pagination };
// };

// type FilterObj = {
//   limit: number;
//   page: number;
//   campaign_id: string;
//   leadform_Id: string;
//   phone_number: string;
//   supplier_id: string;
//   search?: string;
//   leadId?: string;
// };

// interface LeadsDropdownProps {
//   value: any;
//   onChange: (value: any) => void;
//   error?: boolean;
//   errorMessage?: string;
//   label?: string;
//   disabled?: boolean;
//   sx?: any;
//   campaignId?: string;
//   leadFormId?: string;
//   phoneNumber?: string;
//   supplier_id?: string;
//   multiSelect?: boolean;
//   statusList?: any[];
//   leadId?: string;
// }

// const LeadsDropdown: React.FC<LeadsDropdownProps> = ({
//   value,
//   onChange,
//   error = false,
//   errorMessage = '',
//   label = 'Select Role',
//   disabled = false,
//   sx = { mb: 1, mt: 1 },
//   campaignId = null,
//   leadFormId = null,
//   phoneNumber = null,
//   multiSelect = false,
//   supplier_id = null,
//   statusList = [],
//   leadId = null,
// }) => {
//   const { showSnackBar } = useSnackBar();
//   const actions = LeadFormActions();

//   const [filterObj, setFilterObj] = useState<FilterObj>({
//     limit: 20,
//     page: 0,
//     campaign_id: '',
//     leadform_Id: '',
//     phone_number: '',
//     supplier_id: '',
//     leadId: '',
//     search: '',
//   });

//   const [leadResponse, setLeadResponse] = useRecoilState(phoneNumberAllLeadsAtom);
//   const [isLoading, setIsLoading] = useState(false);

//   const reqIdRef = useRef(0);

//   const getUserDetailsByParams = async (curr: FilterObj) => {
//     setIsLoading(true);
//     const myReqId = ++reqIdRef.current;
//     try {
//       const res: ApiResponse = await actions.getUserDetailsByParams(curr);
//       if (myReqId !== reqIdRef.current) return;

//       if (res?.status && res?.data?.leads) {
//         const incoming = res.data.leads ?? [];
//         const hasNext = res.data.pagination ?? {};
//         setLeadResponse((prev) => {
//           if (curr.page === 0) {
//             return { leads: incoming, pagination: hasNext };
//           }
//           const existing = prev.leads;
//           const seen = new Set(existing.map((l) => l.lead_id || l.id));
//           const merged = existing.concat(incoming.filter((l) => !seen.has(l.lead_id || l.id)));
//           return { leads: merged, pagination: hasNext };
//         });
//         if (incoming.length === 0) {
//           showSnackBar('No leads found for the given parameters', 'info');
//         } else {
//           onChange(incoming[0]);
//         }
//       } else if (curr.page === 0) {
//         setLeadResponse({ leads: [], pagination: {} });
//       }
//     } catch (e) {
//       if (reqIdRef.current === myReqId) {
//         showSnackBar('Error fetching leads by params', 'error');
//       }
//     } finally {
//       if (reqIdRef.current === myReqId) setIsLoading(false);
//     }
//   };

//   const loadMoreLeads = () => {
//     if (isLoading) return;
//     if (leadResponse?.pagination?.has_next) {
//       setFilterObj((prev) => ({ ...prev, page: prev.page + 1 }));
//     }
//   };

//    useEffect(() => {
//   if (!value?.lead_id && leadResponse?.leads?.length > 0) {
//     onChange(leadResponse.leads[0]);
//   }
// }, [leadResponse?.leads]);

//   useEffect(() => {
//     if (filterObj.page !== 0 || filterObj.search) {
//       getUserDetailsByParams(filterObj);
//     }
//   }, [filterObj.page, filterObj.search]);

//   // Reset list data when key parameters change
//   useEffect(() => {
//     const newFilterObj = {
//       limit: 20,
//       page: 0,
//       campaign_id: campaignId || '',
//       leadform_Id: leadFormId || '',
//       phone_number: phoneNumber || '',
//       supplier_id: supplier_id || '',
//       leadId: leadId || '',
//       search: '',
//     };

//     // Check if any key parameters have changed
//     const hasParametersChanged =
//       filterObj.campaign_id !== newFilterObj.campaign_id ||
//       filterObj.leadform_Id !== newFilterObj.leadform_Id ||
//       filterObj.phone_number !== newFilterObj.phone_number ||
//       filterObj.leadId !== newFilterObj.leadId ||
//       filterObj.supplier_id !== newFilterObj.supplier_id;

//     if (hasParametersChanged) {
//       // Immediately reset the list data and pagination
//       setLeadResponse({ leads: [], pagination: {} });

//       // Cancel any ongoing requests
//       reqIdRef.current++;

//       // Update filter object
//       setFilterObj(newFilterObj);

//       // Fetch new data if phone number is provided, otherwise keep list empty
//       if (
//         newFilterObj.phone_number ||
//         newFilterObj.campaign_id ||
//         newFilterObj.leadform_Id ||
//         newFilterObj.leadId ||
//         newFilterObj.supplier_id
//       ) {
//         getUserDetailsByParams(newFilterObj);
//       }
//     }
//   }, [campaignId, leadFormId, phoneNumber, supplier_id, leadId]);

//   const handleSearch = (text: string) => {
//     setFilterObj((prev) => ({
//       ...prev,
//       page: 0,
//       search: text?.trim() || '',
//     }));
//   };

//   const getStatusColor = (statusName: string) => {
//     const status = statusList.find((s) => s.status_name === statusName);
//     return status?.colorCode ? `${status.colorCode}` : 'inherit'; // 40 is for 25% opacity
//   };

//   const renderLeadListItem = (lead: Lead) => {
//     const isSelected = lead?.lead_id === value?.lead_id || lead?.id === value?.id;
//     const leadId = lead?.lead_id || lead?.id;
//     const statusName = lead?.status?.status_name ?? '';
//     const statusColor = getStatusColor(statusName || '');

//     return (
//       <ListItem
//         key={lead?.lead_id || lead?.id}
//         onClick={() => onChange(lead)}
//         sx={{
//           backgroundColor: isSelected ? 'rgba(63, 81, 181, 0.1)' : 'transparent',
//           border: 'solid 1px #EAEAEA',
//           borderRadius: '4px',
//           '&:hover': {
//             cursor: 'pointer',
//             backgroundColor: isSelected ? '#fff' : 'rgba(0, 0, 0, 0.05)',
//           },
//           // borderLeft: statusName ? `4px solid ${statusColor}` : 'none',
//           paddingLeft: statusName ? 2 : 3,
//           position: 'relative',
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
//           {/* Status Color Indicator */}
//           {statusName && (
//             <Box
//               sx={{
//                 width: 12,
//                 height: 12,
//                 borderRadius: '50%',
//                 backgroundColor: statusColor,
//                 flexShrink: 0,
//               }}
//             />
//           )}

//           {/* Main Content */}
//           <ListItemText
//             primary={
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   flexWrap: 'wrap',
//                   fontWeight: '500',
//                   color: '#4F5457',
//                 }}
//               >
//                 <span>{leadId}</span>
//               </Box>
//             }
//             // secondary={
//             //   lead?.status?.status_name ?? dateFormate(lead?.created_at, 'DD-MM-YYYY HH:mm A')
//             // }
//             // sx={{ flex: 1 }}
//           />
//         </Box>

//         {/* View Chip Button */}
//         <ListItemSecondaryAction>
//           <Tooltip title="View Details">
//             <IconButton
//               edge="end"
//               size="small"
//               onClick={() => onChange(lead)}
//               sx={{
//                 color: 'primary.main',
//                 '&:hover': {
//                   backgroundColor: 'primary.light',
//                   color: 'white',
//                 },
//               }}
//             >
//               <VisibilityIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </ListItemSecondaryAction>
//       </ListItem>
//     );
//   };

//   return (
//     <>
//       {(leadResponse?.leads?.length ?? 0) > 3 ? (
//         <SearchableDropdown
//           options={leadResponse?.leads || []}
//           label={label}
//           value={value}
//           onChange={onChange}
//           fetchMoreOptions={loadMoreLeads}
//           onSearch={handleSearch}
//           valueKey="lead_id"
//           loading={isLoading}
//           error={error}
//           errorMessage={errorMessage}
//           disabled={disabled}
//           sx={sx}
//           multiSelect={multiSelect ?? false}
//           getOptionLabel={(option: Lead) =>
//             option?.lead_id
//               ? `${option.lead_id} ${option?.status?.status_name ? `- ${option?.status?.status_name}` : ''}`
//               : `${option?.id} ${option?.status?.status_name ? `- ${option?.status?.status_name}` : ''}`
//           }
//         />
//       ) : (
//         <>
//           {leadResponse?.leads?.length > 0 && (
//             <>
//               <Typography sx={{ mt: 2, color: 'text.main' }}>Select Leads</Typography>
//               <List sx={{ padding: 0, color: 'secondary.main !important', fontWeight: '500' }}>
//                 {leadResponse?.leads?.map((lead) => renderLeadListItem(lead))}
//               </List>
//             </>
//           )}
//         </>
//       )}
//     </>
//   );
// };

// export default LeadsDropdown;

// // New Component
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Box,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { useRecoilState } from 'recoil';

import { LeadFormActions } from '../../../Services/_actions';
import { leadsTableStateAtom } from '../../../Services/_states';
import { Lead } from '../../../interfaces/Leads.interface';

/* ---------------- TYPES ---------------- */
interface LeadsDropdownProps {
  value: any;
  onChange: (value: any) => void;
  campaignId?: string | null;
  leadFormId?: string | null;
  phoneNumber?: string | null;
  leadId?: string | null
}

/* ---------------- COMPONENT ---------------- */
const LeadsDropdown: React.FC<LeadsDropdownProps> = ({
  value,
  onChange,
  campaignId,
  leadFormId,
  phoneNumber,
  leadId = null,
}) => {
  const actions = LeadFormActions();
  const [tableState, setTableState] = useRecoilState<any>(leadsTableStateAtom);
  const [isLoading, setIsLoading] = useState(false);
  const lastScrollTopRef = useRef(0);
  const finalCampaignId = campaignId;
  const finalLeadFormId = leadFormId;
  const finalPhoneNumber = phoneNumber;

  /* ---------------- STATUS COLOR ---------------- */
  // const getStatusColor = (statusName: string) => {
  //   const status = statusList.find((s) => s.status_name === statusName);
  //   return status?.colorCode || 'transparent';
  // };

  /* ---------------- INITIAL FETCH ---------------- */
  const fetchInitialLeads = async () => {
    try {
      setIsLoading(true);

      const response = await actions.getB2b2CLeads({
        campaign_id: finalCampaignId,
        leads_form_id: finalLeadFormId,
        search: finalPhoneNumber,
        limit: 100,
        offset: 0,
      });

      const leads: Lead[] = response?.data?.list || [];
      const totalCount = response?.data?.count || leads.length;

      setTableState({
        data: leads,
        totalCount,
        filters: {
          campaign_id: finalCampaignId,
          leads_form_id: finalLeadFormId,
          search: finalPhoneNumber,
          limit: 100,
          offset: leads.length,
        },
      });
    } catch (error) {
      console.error('Initial leads fetch failed', error);
    } finally {
      setIsLoading(false);
    }
  };

  /* ---------------- FETCH MORE ---------------- */
  const fetchMoreLeads = async () => {
    if (isLoading) return;

    const fetched = tableState?.data?.length || 0;
    const total = tableState?.totalCount || 0;

    if (fetched >= total) return;

    try {
      setIsLoading(true);

      const response = await actions.getB2b2CLeads({
        ...tableState.filters,
        offset: fetched,
      });

      const newLeads: Lead[] = response?.data?.list || [];

      setTableState((prev: any) => ({
        ...prev,
        data: [...prev.data, ...newLeads],
        filters: {
          ...prev.filters,
          offset: fetched + newLeads.length,
        },
      }));
    } catch (error) {
      console.error('Pagination fetch failed', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLUListElement>) => {
      const target = e.currentTarget;
      const scrollTop = target.scrollTop;

      if (scrollTop <= lastScrollTopRef.current) return;
      lastScrollTopRef.current = scrollTop;

      const bottomReached =
        target.scrollHeight - target.scrollTop <= target.clientHeight + 50;

      if (bottomReached) fetchMoreLeads();
    },
    [tableState, isLoading]
  );
  const setLeadWebFormDataIfNotExists = (resData) => {
    const existingData = localStorage.getItem('leadWebFormData');
    if (!existingData) {
      const payload = {
        campaign: resData?.campaign || {},
        webForm: resData?.web_form || {},
        phoneNumber: resData?.data?.phone_number || '',
      };
      localStorage.setItem('leadWebFormData', JSON.stringify(payload));
    }
    if (resData?.data) {
      onChange(resData?.data)
    }
  };


  const fetchLeadDetails = async (leadId) => {
    if (!leadId) return;

    try {
      setIsLoading(true);
      const res = await actions.getLeadV1(leadId);
      if (res?.status === 200) {
        setLeadWebFormDataIfNotExists(res?.data);
        window.dispatchEvent(new Event('storage'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  /* ---------------- FIRST LOAD ---------------- */
  useEffect(() => {
    if (leadId) {
      fetchLeadDetails(leadId)
    } else {
      fetchInitialLeads();
    }
  }, [finalCampaignId, finalLeadFormId, finalPhoneNumber, leadId]);

  /* ---------------- AUTO SELECT ---------------- */
  // Intentionally disabled: do not auto-select a lead by default.

  /* ---------------- RENDER ITEM ---------------- */
  const renderLead = (lead: Lead | null) => {
    if (!lead) return null;
    const isSelected = lead?.lead_id === value?.lead_id;
    // const statusName = lead?.last_status?.status_name || '';
    // const statusColor = getStatusColor(statusName);

    return (
      <ListItem
        key={lead.lead_id}
        onClick={() => onChange(lead)}
        sx={{
          border: '1px solid #EAEAEA',
          borderRadius: 1,
          mb: 0.5,
          cursor: 'pointer',
          backgroundColor: isSelected
            ? 'rgba(63,81,181,0.1)'
            : '#fff',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* {statusName && (
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: statusColor,
              }}
            />
          )} */}

          <ListItemText
            primary={lead.lead_id}
          // secondary={statusName}
          />
        </Box>

        <ListItemSecondaryAction>
          <Tooltip title="View Lead">
            <IconButton size="small" onClick={() => onChange(lead)}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  /* ---------------- UI ---------------- */
  return (
    <>
      <Typography sx={{ mb: 1 }}>Select Lead</Typography>
      {leadId ? (
        <List
          sx={{ maxHeight: 350, overflow: 'auto' }}
          onScroll={handleScroll}
        >
          {[value]?.map(renderLead)}
        </List>
      ) :
        <List
          sx={{ maxHeight: 350, overflow: 'auto' }}
          onScroll={handleScroll}
        >
          {tableState?.data?.map(renderLead)}
        </List>
      }
      {isLoading && (
        <Typography align="center" sx={{ mt: 1 }}>
          Loading...
        </Typography>
      )}
    </>
  );
};

export default LeadsDropdown;
